import React from "react";

const ModalLoader = () => {
  return (
    <>
      <div className="modalLoaderWrapper">
        <div className="loadingContentWrapper">
        <div className="loadingContent">
          {/* <p>Your discount is being applied. Just a moment, please.</p> */}
          <p style={{ color: '#3d6aae'}}>We're in the process of applying your coupon. Thank you for your patience.</p>
        </div>
        <div className="modalLoader"></div>
        </div>
      </div>
    </>
  );
};

export default ModalLoader;
